import { IBrand } from "./ibrand";

export const Brand: IBrand = {
  navbarTitle: 'Preventor',
  brandTitle: 'Preventor',
  brandName: "Preventor",
  mockBackendUrl: 'https://si-test.preventor-player-ui-backend-mock.silabs.se',
  prodBackendUrl: '/api',
  dialogUrl: 'assets/dialogs/',
  targetOrigin: '*',
  defaultLocale: 'sv-SE',
  supportedLocales: ['sv-SE'],
  messagesEnabled: true,
  showQuestionCounter: false,
  nextButtonInQuestion: false,
  resultLayout: 'separate',
  selfAssessmentFirst: false,
  tipsLayout: 'grid',
  cmsMockUrl: 'https://localhost:5001',
  cmsProdUrl: '',
  cmsMockApiKey: 'ABCD1234',
  cmsProdApiKey: ''
};
